import { FC } from 'react'
import styles from './LoadingCircle.module.scss'

/**
 * @deprecated Sunset
 */
export const LoadingCircle: FC = () => <span className={styles.container} />
